<template>
    <div class="package-status container mt-4">
        <b-alert variant="warning" show v-if="showTrueShippingMessage">
            This order is shipping directly to a single location and will be sorted using the information provided below.
        </b-alert>
<!--        <b-alert variant="danger" show>We are aware of issues affecting shipment updates in our system. For the latest information please check the link to UPS/FedEx.</b-alert>-->
        <div class="h2">Shipment Status</div>
        <div v-if="isLoading">
            Loading your order....
        </div>
        <div v-else-if="order === null && this.isLegacyPage">
            Your order is still being processed. Please check again later!
        </div>
        <div v-else>
            <b-card-group style="margin-bottom:20px;">
                <b-card
                    :title="schoolName"
                >
                    <h5>
                        Invoice # {{ invoiceId }}
                        <span v-if="poNumber"><br />PO # {{ poNumber }}</span>
                    </h5>
                    <p v-if="hasBegunProcessing">
                        You have {{ totalShippedOrders }} packages that are being
                        shipped, {{ totalPendingOrders }} pending packages, and
                        {{ totalOnlineOrders}} online orders.
                    </p>
                    <div v-else>
                        <p>
                            Your order has been received.
                        </p>
                        <div v-if="orderedProducts.length">
                            <h6 class="font-weight-bold">Items on Your Order:</h6>
                            <b-table
                                small
                                striped
                                bordered
                                :items="orderedProducts"
                                :fields="ordered_products_key"
                            ></b-table>
                        </div>
                    </div>
                </b-card>
            </b-card-group>

            <b-card-group
                v-if="numPackagesHandled == 0 && subOrderOnly"
                style="margin-bottom:20px;"
            >
                <b-card
                    title="We were unable to find the requested shipping information for this specific order."
                >
                    <p>
                        Please try again later or contact customer service at  <a href="mailto:orders@studiesweekly.com">orders@studiesweekly.com</a>  for more information.
                    </p>

                </b-card>
            </b-card-group>

            <b-card-group
                v-if="order && order.outages && order.outages.length"
                style="margin-bottom:20px;"
            >
                <b-card
                    title="Blackout Windows"
                >
                    <p>
                        If you would like to update the dates you are unable to
                        receive your packages, please contact
                        <a
                            :href="email_link"
                        >orders@studiesweekly.com</a>.
                        Thank you!
                    </p>

                    <b-row>
                        <b-col
                            cols="6"
                            sm="3"
                            md="2"
                            class="font-weight-bold"
                        >
                            Start Date
                        </b-col>
                        <b-col
                            cols="6"
                            sm="3"
                            md="2"
                            class="font-weight-bold"
                        >
                            End Date
                        </b-col>
                    </b-row>
                    <b-row
                        v-for="outage in order.outages"
                        :key="outage.ID"
                    >
                        <b-col
                            cols="6"
                            sm="3"
                            md="2"
                        >
                            {{ outage.start }}
                        </b-col>
                        <b-col
                            cols="6"
                            sm="3"
                            md="2"
                        >
                            {{ outage.end }}
                        </b-col>
                    </b-row>
                </b-card>
            </b-card-group>

            <b-card-group
                v-for="(school,i) in schools"
                v-if="school.packages.length || school.online_orders.length || school.pending_orders.length"
                :key='`${school.name}_${i}`'
                style="width: 100%;"
            >
                <b-card
                    :title="getSchoolTitle(school)"
                    header-tag="header"
                    footer-tag="footer"
                    class="mb-4"
                >
                    <b-card-text>
                        {{school.address}}, {{school.city}}, {{school.state}} {{school.zip}}
                    </b-card-text>

                    <div v-if="school.online_orders.length">
                        <h4>Online Only Orders</h4>
                        <b-table
                            striped
                            hover
                            :items="school.online_orders"
                            :fields="online_orders_key"
                        >
                            <template #cell(sku)="data">
                                {{ data.item.sku }}
                            </template>
                        </b-table>
                    </div>

                    <h4 v-if="school.packages.length">
                        Print Publications
                    </h4>
                    <div v-if="school.packages.length">
                        <h5>Packages</h5>
                        <b-table-simple
                            striped
                            hover
                            :items="school.packages"
                            :fields="packages_key"
                        >
                            <b-thead>
                                <b-tr>
                                    <b-th v-for="(header, j ) in packages_key" :key="`header_${i}_${j}`">{{ header }}</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <template v-for="(items, groupId, k) in school.packagesByGroupId" style="border: 1px solid #ccc; margin-bottom:10px;">
                                    <!-- Group Packages -->
<!--                                    <template v-if="items.count > 1"></template>-->
                                    <!-- Individual Packages -->
<!--                                    <template v-else></template>-->
                                    <b-tr v-for="(item, l) in items" :key="`item_${i}_${k}_${l}`">
<!--                                        <template v-if="item.carrier == 'FREIGHT'"></template>-->
                                        <template>
                                        <b-td>
                                            <template v-if="items.length == 1">{{ item.sku }} ({{ item.subject }})</template>
                                            <template v-else>Combined Package:</template>
                                        </b-td>
                                        <b-td>
                                            <template v-if="items.length == 1">{{ item.grade }}</template>
                                            <template v-else></template>
                                        </b-td>
                                        <b-td>
                                            <template v-if="items.length == 1">{{ item.quantity }}</template>
                                            <template v-else></template>
                                        </b-td>
                                        <b-td>
                                            <template v-if="infoByTrackingId[item.tracking_number]">
                                                {{infoByTrackingId[item.tracking_number].carrier}}
                                            </template>
                                            <template v-else>
                                                {{ item.carrier }}
                                            </template>
                                        </b-td>
                                        <b-td v-if="showTrackingColumn">
                                            <template v-if="item.shipping_status === 'shipped'">
                                                <a v-if="item.tracking_number"
                                                   :href="(infoByTrackingId[item.tracking_number] || {}).url"
                                                   target="_blank"
                                                >
                                                    {{ item.tracking_number }}
                                                </a>
                                                <div v-if="!item.tracking_number">
                                                    <i>tracking available soon</i>
                                                </div>
                                            </template>
                                            <template v-else>
                                                N/A
                                            </template>
                                        </b-td>
                                        <b-td v-if="showTrackingColumn">
                                            <template>
                                                {{ getDeliveryText(item) }}
                                            </template>
                                        </b-td>
                                        <b-td v-if="showTrackingColumn">
                                            <template v-if="item.shipping_status === 'shipped'">
                                                {{ item.delivery_date_formatted }}
                                            </template>
                                            <template v-else>
                                                N/A
                                            </template>
                                        </b-td>
                                        </template>
                                    </b-tr>
                                    <!-- Show Item List -->
                                    <b-tr v-if="items.length > 1" style="border: 1px solid #ccc; margin:10px 0; cursor: pointer" v-b-toggle="`collapse_${i}_${k}`">
                                        <b-td :colspan="packages_key.length" class="pl-5">
                                            <b-btn variant="outline-dark" size="sm" class="py-0 px-1 m-0">
                                                <span class="when-closed">Open for Combined Package details...</span>
                                                <span class="when-open">Close details</span>
                                            </b-btn>
                                            <b-collapse :id="`collapse_${i}_${k}`" class="w-100" visible :colspan="items.length">
                                            <b-table-simple small striped bordered>
                                                <b-thead>
                                                    <b-tr><b-th colspan="3">Items in Package:</b-th></b-tr>
                                                    <b-tr>
                                                        <b-th>Sku</b-th>
                                                        <b-th>Grade</b-th>
                                                        <b-th>Quantity</b-th>
                                                    </b-tr>
                                                </b-thead>
                                                <b-tbody>
                                                    <b-tr v-for="(item, m) in items" :key="`summary_${i}_${k}_${m}`">
                                                        <b-td>{{ item.sku }} ({{item.subject}})</b-td>
                                                        <b-td>{{ item.grade }}</b-td>
                                                        <b-td>{{ item.quantity }}</b-td>
                                                    </b-tr>
                                                </b-tbody>
                                            </b-table-simple>
                                            </b-collapse>
                                        </b-td>
                                    </b-tr>
                                </template>
                            </b-tbody>
                        </b-table-simple>
                    </div>

                    <div v-if="school.pending_orders.length">
                        <h5>Pending Orders</h5>
                        <b-table
                            striped
                            hover
                            :items="school.pending_orders"
                            :fields="pending_orders_key"
                        >
                            <template #cell(sku)="data">
                                <div>
                                    {{ data.item.sku }}
                                    <span
                                        v-if="delayed_skus[data.item.sku]"
                                        class="text-danger"
                                    >
                                        (delayed)
                                    </span>
                                </div>
                                <div
                                    v-if="delayed_skus[data.item.sku]"
                                    class="text-danger"
                                >
                                    <div
                                        v-for="status in delayed_skus[data.item.sku]"
                                        :key="status.ID"
                                        class="text-danger"
                                    >
                                        {{ status.reason }}
                                    </div>
                                </div>
                            </template>
                        </b-table>
                    </div>
                </b-card>
            </b-card-group>
        </div>
    </div>
</template>

<script>

export default {
    name: 'package_status',
    props: ['access_key', 'invoice_id', 'sub_order_id'],
    data: () => ({
        isLoading: true,
        order: null,
        schools: {},
        packages: [],
        packagesByTrackingId: {},
        infoByTrackingId: {},

        delayed_skus: {},

        numPackagesHandled: 0, // move to computed

        online_orders_key: [
            {
                key: 'sku',
                label: 'Product',
                tdClass: 'text-nowrap'
            },
            // {
            //     key: 'classrooms',
            //     label: 'Classrooms'
            // },
            {
                key: 'quantity',
                label: 'Qty'
            },
        ],
        pending_orders_key: [
            {
                key: 'sku',
                label: 'Product',
                tdClass: 'text-nowrap'
            },
            // {
            //     key: 'classrooms',
            //     label: 'Classrooms'
            // },
            {
                key: 'quantity',
                label: 'Total Qty'
            },
        ],
        packages_key: [
            'Sku',
            'Grade',
            'Quantity',
            'Carrier',
            'Tracking #',
            'Delivery Status',
            'Delivery Date'
        ],
        ordered_products_key: [
            { key: 'sku', label: 'SKU' },
            { key: 'description', label: 'Description' },
            { key: 'quantity', label: 'Qty' },
        ],
    }),

    computed: {
        showTrueShippingMessage() {
            return this.packages.some(pkg => pkg.true_shipping === 1);
        },
        showTrackingColumn() {
            return this.packages.some(pkg => pkg.shipping_status === 'shipped');
        },
        hasBegunProcessing() {
            return this.totalPendingOrders > 0 || this.totalShippedOrders > 0 || this.totalOnlineOrders > 0;
        },
        totalPendingOrders() {
            return this.shownOrders.filter(this.isPending).length;
        },
        totalOnlineOrders() {
            return this.shownOrders.filter(this.isOnlineOnly).length;
        },
        totalShippedOrders() {
            return this.shownOrders.filter(this.isShipped).length;
        },
        shownOrders() {
            if (this.subOrderOnly)
                return this.packages.filter(pkg => this.suborderIds.includes(pkg.subOrderID.toString()));
            return this.packages;
        },
        subOrderOnly() {
            return !!this.$route.params.sub_order_id;
        },
        suborderIds() {
            return this.subOrderOnly ? this.$route.params.sub_order_id.split(',') : [];
        },
        email_link() {
            function urlencode(text) {
                return encodeURI(text.replace(/ +/g,' '))
            }
            const to = 'orders@studiesweekly.com'
            const subject = urlencode(
                `Blackout window change for ${this.schoolName}`
            )
            const body = urlencode(`\n\n\n
                Please do not remove the following. We use it to find your order.
                Invoice # ${this.invoiceid}
                PO # ${this.poNumber}
            `)
            return `mailto:${to}?subject=${subject}&body=${body}`
        },
        invoiceId() {
            return this.$route.params.invoice_id;
        },
        poNumber() {
            return (this.order || {}).ponumber;
        },
        isLegacyPage() {
            return (this.packages && this.packages.length) ? this.isLegacy(this.packages[0]) : true;
        },
        orderedProducts() {
            if (!this.order) return [];
            const products = [];
            for (const subOrderID of (this.order.suborderIDs || [])) {
                const suborder = this.order[subOrderID];
                if (!suborder) continue;
                for (const productID of (suborder.productIDs || [])) {
                    const product = suborder[productID];
                    if (!product) continue;
                    products.push({
                        sku: product.sku,
                        description: product.description,
                        quantity: product.quantity,
                    });
                }
            }
            return products;
        },
        schoolName() {
            if (this.order)
                return this.order.portal_schoolname;

            if (this.packages && this.packages.length)
                return this.packages[0].shipping_school_name;

            return '';
        }
    },

    async mounted() {
        document.title = "Shipment Status For Invoice # " + this.invoiceId
        this.getPackageStatus()
    },

    methods: {
        async getPackageStatus() {
            this.isLoading = true;
            let response = await this.$store.dispatch('getPackageStatus', {access_key: this.$route.params.access_key, invoice_id:this.$route.params.invoice_id})
            this.isLoading = false;

            // Legacy page needs the order, the new page does not.
            if (response.data.order) {
                this.order = response.data.order.data;
                this.order.invoiceid = this.$route.params.invoice_id
            }

            this.packages = response.data.packages;
            if (!this.packages.length) {
                return;
            }


            // Get online_only/pending/shipped products for each school
            this.filterPackagesBySchoolAndStatus(this.order, this.packages);

        },
        filterPackagesBySchoolAndStatus(order, packages) {
            packages.sort(this.packageSort);

            for (const pkg of packages) {
                let school = this.createSchool(pkg);

                if (!this.shouldProcessPackage(school, pkg))
                    continue;

                // Update Fields
                pkg.tracking_number_url = this.getTrackingLink(pkg);
                pkg.delivery_date_formatted = this.getFormattedDeliveryDate(pkg);
                this.numPackagesHandled++;

                // Place in pending/online/shipped categories
                this.placePackageInCategory(school, pkg);
            }
        },
        placePackageInCategory(school, pkg) {

            // Is Legacy?
            if (this.isLegacy(pkg)) {
                this.handleLegacyPackage(school, pkg);
                return;
            }

            // Pending Package
            if (this.isPending(pkg)) {
                school.pending_orders.push({
                    sku: pkg.sku,
                    classrooms: 0,
                    quantity: pkg.quantity,
                });
                return;
            }

            // Online Only
            if (this.isOnlineOnly(pkg)) {
                school.online_orders.push(pkg);
                return;
            }

            // Print Online
            if (this.isPrintAndOnline(pkg)) {
                this.placePackageInGroup(school, pkg);

                // Increment # of packages by SKU
                if (!school.packages_by_sku[pkg.sku])
                    school.packages_by_sku[pkg.sku] = 0;

                school.packages_by_sku[pkg.sku]++
                return;
            }

        },
        placePackageInGroup(school, pkg) {

            school.packages.push(pkg);

            // Place in tracking number group
            if (!school.hasOwnProperty('packagesByGroupId'))
                school.packagesByGroupId = {};

            if (!pkg.tracking_number) {
                school.packagesByGroupId[pkg.package_id] = [pkg];
                return;
            }

            if (!school.packagesByGroupId.hasOwnProperty(pkg.tracking_number))
                school.packagesByGroupId[pkg.tracking_number] = [];

            school.packagesByGroupId[pkg.tracking_number].push(pkg);

            school.packagesByGroupId[pkg.tracking_number].sort(this.packageSort);

        },
        handleLegacyPackage(school, pkg) {
            // Find Matching suborder
            if (!this.order.hasOwnProperty(pkg.subOrderID))
                return null;
            let orderData = this.order[pkg.subOrderID];

            // Find matching SKU
            let skuData = Object.values(orderData).find(x => typeof x === 'object' && x.hasOwnProperty('sku') && x.sku === pkg.sku);
            if (!skuData)
                return null;

            // Online Only
            if (skuData.online_only) {
                // Show 1 entry only for online only
                if (school.online_orders.find(x => x.sku === pkg.sku))
                    return;

                pkg.quantity = parseInt(skuData.quantity);

                school.online_orders.push(pkg);
                return;
            }

            // Shipped Package
            school.packages.push(pkg);
            if (!school.packages_by_sku[pkg.sku]) {
                school.packages_by_sku[pkg.sku] = 0
            }
            school.packages_by_sku[pkg.sku]++
        },
        createSchool({invoice_id, shipping_name, shipping_address, shipping_city, shipping_state, shipping_zip, shipping_school_name, subOrderID}) {
            if (!this.schools.hasOwnProperty(subOrderID)) {
                this.schools[subOrderID] = {
                    subOrderID: subOrderID,
                    name: shipping_school_name,
                    address: shipping_address,
                    city: shipping_city,
                    state: shipping_state,
                    zip: shipping_zip,
                    billing_name: shipping_school_name,
                    products: [],
                    online_orders: [],
                    packages: [],
                    pending_orders: [],
                    packages_by_sku: {},
                }
            }
            return this.schools[subOrderID];
        },
        async getProductStatuses(product_ids) {
            const response = await this.$store.dispatch('getProductStatuses', {product_ids: Object.keys(product_ids)});
            for (const status of response.data) {
                const sku = product_ids[status.productID]
                if (!this.delayed_skus[sku]) {
                    this.delayed_skus[sku] = []
                }
                this.delayed_skus[sku].push(status)
            }
            this.$forceUpdate()
        },

        shouldProcessPackage(school, pkg) {
            // No school found
            if (!school)
                return false;

            // No quantity
            if (pkg.quantity <= 0)
                return false;

            // If we are only showing a specific suborder, skip others
            if (this.subOrderOnly && pkg.subOrderID && !this.suborderIds.includes(pkg.subOrderID.toString()))
                return false;

            return true;
        },

        isLegacy(pkg) {
            return !pkg.hasOwnProperty('features')
        },
        isPending(pkg) {
            return pkg.shipping_status === 'pending';
        },
        isOnlineOnly(pkg) {
            return pkg.features === 'Online Only';
        },
        isPrintAndOnline(pkg) {
            return pkg.features === 'Print & Online';
        },
        isShipped(pkg) {
            return pkg.shipping_status === 'shipped';
        },

        packageSort(a,b,) {
            // if either has carrier='FREIGHT' sort it last
            return (a.carrier === 'FREIGHT' ? 1 : 0) - (b.carrier === 'FREIGHT' ? 1 : 0)
                || (a.shipping_school_name.localeCompare(b.shipping_school_name))
                || (a.grade == 'Kindergarten') ? -1 : (a.grade.localeCompare(b.grade))
                || (a.quantity - b.quantity);
        },

        getTrackingLink(pkg) {
            let link = null;
            if (pkg.carrier.match(/fedex/i))
                link = `https://www.fedex.com/fedextrack/?trknbr=${pkg.tracking_number}`;

            if (pkg.carrier === 'UPS')
                link = `http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=${pkg.tracking_number}&loc=en_us`;

            if (link)
                this.infoByTrackingId[pkg.tracking_number] = {url: link, carrier: pkg.carrier};

            return link;
        },
        getFormattedDeliveryDate(pkg) {
            if (pkg.delivery_date_formatted) {
                const temp_delivery_date = pkg.delivery_date_formatted.toLowerCase()
                return temp_delivery_date.charAt(0).toUpperCase() + temp_delivery_date.slice(1)
            }

            if (pkg.delivery_date && pkg.delivery_date != "0") {
                let date = new Date(parseInt(pkg.delivery_date) * 1000);
                return `${date.toLocaleString()}`;
            }
        },
        getSchoolTitle(school) {
            // return `(${school.subOrderID}) ${school.name}`;
            return school.name;
        },
        getDeliveryText(pkg) {
            switch (pkg.delivery_status) {
                case 'DELIVERED':
                    return 'Delivered';
                case 'IN TRANSIT':
                    return 'In Transit';
                default:
                    return 'Not Yet Shipped';
            }
        }
    },
}
</script>

<style scoped lang="scss">
.collapsed .when-open,
.not-collapsed .when-closed {
    display: none;
}
</style>
